import { tns } from 'tiny-slider/src/tiny-slider';

class LogosSlider {
	constructor(el) {
		this.el = el;

		const logosSlider = tns({
			container: this.el,
			responsive: {
				350: {
					items: 2
				},
				500: {
					items: 3
				},
				700: {
					items: 5
				}

			},
			autoplay: true,
			autoplayButtonOutput: false,
			mouseDrag: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 400,
			controls: false
		});

		return logosSlider;
		
	}
}

export default LogosSlider;